<template>
    <v-app class="fundo">
        <div class="page">

            <v-app-bar fixed dark flat color="primary" class="d-print-none">
                <v-btn icon dark @click="Fechar()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{titulo}}</v-toolbar-title>
                <v-spacer/>
                <div class="mx-4" v-if="fonteVariavel">
                    <v-btn icon dark @click="AumentarFonte()"><v-icon>mdi-format-font-size-increase</v-icon></v-btn>
                    <v-btn icon dark @click="DiminuirFonte()"><v-icon>mdi-format-font-size-decrease</v-icon></v-btn>
                </div>
                <v-toolbar-items v-if="exportarExcel">
                    <v-btn dark text @click="ExportarExcel('tabela')"><v-icon left>mdi-file-excel-outline</v-icon>Exportar (Excel)</v-btn>
                </v-toolbar-items>
                <v-toolbar-items>
                    <v-btn dark text @click="Imprimir()"><v-icon left>mdi-printer</v-icon>Imprimir</v-btn>
                </v-toolbar-items>
                
            </v-app-bar>

            <v-card flat class="subpage">

                <div v-if="!recibo">

                    <div v-if="cabecalhoCompleto">                    
                        <v-row :style="$vuetify.breakpoint.smAndDown ? 'height: 150px' : 'height: 95px'">
                            
                            <v-col sm="6">
                                <!-- <img v-if="app.empresaLogo" :src="`data:image/jpeg;base64,${app.empresaLogo}`"> -->
                                <img src="@/assets/images/Bliks_colorido.png" class="logo">
                            </v-col>
                                                                
                            <v-col sm="6" class="text-right" style="line-height: 1">
                                <span class="text-uppercase font-weight-bold" style="font-size: 80%">{{empresa.nomeCnpj}}</span> <br/>
                                <span class="text-uppercase text-caption" style="font-size: 70%"> {{empresa.logradouro}} </span> <br/>
                                <span class="text-uppercase text-caption" style="font-size: 70%"> {{empresa.cep}} - {{empresa.bairro}} - {{empresa.estado}} - {{empresa.cidade}}</span> <br/>
                                <span class="text-caption" style="font-size: 70%">{{empresa.telefone1}}</span> <span v-if="empresa.telefone2" class="text-caption" style="font-size: 70%"> / {{empresa.telefone2}}</span> <br/>
                                <span class="text-lowercase text-caption" style="font-size: 70%">{{empresa.email}}</span>
                                <span v-if="emissao" class="font-weight-bold text-uppercase text-caption" style="font-size: 70%">Emissão: {{new Date(emissao).ddmmyyyy()}}</span> <br/> <br/> 
                            </v-col>
                        </v-row>
                    </div>

                    <div v-else>
                        <v-row>
                            <v-col sm="6">
                                <img src="@/assets/images/Bliks_colorido.png" class="logo">
                            </v-col>
                            <v-col sm="6" class="text-right"> 
                                <p class="overline">  Giom Tecnologia <br/> {{new Date()}} </p>
                            </v-col>
                        </v-row>
                    </div>  

                    <hr class="solid">
                    
                    <v-row>                                
                        <v-col cols="12" class="text-center">
                            <span class="text-uppercase font-weight-bold">{{titulo}}</span>
                        </v-col>                                
                    </v-row>

                    <hr class="solid">

                </div>

                <div>
                    <slot/>
                </div>

            </v-card>

        </div>
    </v-app>
</template>

<script>
import { EmpresaService } from '../../core/services/geral';
import { TableToExcel } from "@/assets/js/custom"
export default {

    data: () =>({
        empresa: {},
        sessionApp: {},
        root: null
    }),
    props:{
        titulo: '',
        cabecalhoCompleto: null,
        fonteVariavel: {
            default: false
        },
        paisagem:{
            required: true
        },
        exportarExcel:{
            required: true
        },
        recibo: false,
        emissao: null,
        trazEmpresa: {
            default: true
        }
    },
    created(){
        if(this.trazEmpresa){
            this.sessionApp = JSON.parse(localStorage.sessionApp);
            
            const empresaService = new EmpresaService();

            empresaService.ObterPorId(this.sessionApp.empresaId).then(
                res=> {
                    this.empresa = res.data
                },
                err=>{
                    this.$swal('Aviso', err.message, 'error');
                }
            )
        }
    },
    mounted(){

        this.root = document.body;

        if(this.paisagem){
            this.root.style.setProperty("--widthPage", 29.7 + 'cm');
            this.root.style.setProperty("--min-heightPage", 19 + 'cm');
            this.setPageSize('landscape')
        }      
        else{
            this.root.style.setProperty("--widthPage", 21 + 'cm');
            this.root.style.setProperty("--min-heightPage", 26 + 'cm');
            this.setPageSize('portrait')
        }
    },
    methods: {
        setPageSize(size){
            const style = document.createElement('style');
            style.innerHTML = `@page {size: ${size}}`;
            document.head.appendChild(style);
        },
        AumentarFonte(){
            var raiz = getComputedStyle(this.root);
            var valor = parseFloat(raiz.getPropertyValue('--fontSize').replace("%", ""));
            valor += 5;
            document.documentElement.style.setProperty("--fontSize", valor + '%');
        },
        DiminuirFonte(){
            var raiz = getComputedStyle(this.root);
            var valor = parseFloat(raiz.getPropertyValue('--fontSize').replace("%", ""));
            valor -= 5;
            document.documentElement.style.setProperty("--fontSize", valor + '%');
        },
        ExportarExcel(tabela, worksheet){
            TableToExcel(tabela, worksheet);
        },
        Imprimir(){
            window.print();
        },
        Fechar(){
            window.close();
        }
    }
    
}
</script>

<style>

:root{
    --fontSize: 75%;
}

.subpage {
    margin: 0.5cm;
}

.fonte {
    font-size: var(--fontSize) !important;
}

@media only screen and (pointer: fine){

    :root{

        /* DESKTOP */
        --widthPage: 0cm;
        --min-heightPage: 0cm;

    }

   .fundo {
        background-color: #a7a7a7 !important;
   }

   .page{

        width: var(--widthPage);
        min-height: var(--min-heightPage);

        height: calc(100/23 * 19vh) auto;

        margin: 2cm auto;
        border: 1px #D3D3D3 solid;
        border-radius: 5px;
        background: white;
    }

    .logo{
        display: block;
        margin-left: 1vw;
        margin-top: 1vh;
        width: 15%;
    }

    #background{
        position:absolute;
        z-index:1;
        
        display:block;
        opacity: 0.5;
    }

    #bg-text
    {
        color:lightgrey;
        font-size: 10em;
        margin-top: 50%;
        transform:rotate(300deg);
        -webkit-transform:rotate(330deg);
    }
}

@media only screen and (pointer: coarse){
   .fundo {
      background-color: #a7a7a7 !important
   } 
   .page{
      width: calc(100/23 * 21vw);
      height: calc(100/23 * 29.7vh) auto;
      margin: 2cm auto;
      border: 1px #cccccc solid;
      border-radius: 5px;
      background: rgb(255, 255, 255);
   }
   .logo{
        width: 15vw;
        margin-top: 5vh;
    }
    .header{
        width: 100%;
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
    }

    #background{
        position:absolute;
        z-index:1;
        width: 20px;
        display:block;
        opacity: 0.5;
    }

    #bg-text
    {
        color:lightgrey;
        text-align: center;
        font-size: 13vh;
        margin-top: 20vh;
        margin-left: 35vw;
        word-break: break-all;
        line-height: 12vh;
    }
}

@media print{

    .hidden-print{
        display: none !important;
    }

   .page{

    width: var(--widthPage);
    min-height: var(--min-heightPage);

    height: calc(100/23 * 21vh) auto;
    background: initial;
    background-color: #ffffff !important;
    -webkit-print-color-adjust: exact;
   }

   .subpage{
      margin: 0cm;
      background-color: #ffffff !important
   }

   .fundo {
      background-color: #ffffff !important
   }

   .logo{
        display: block;
        margin-top: initial;
        margin-left: 0vw;
        width: 15%;
    }

    .header{
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
    }

    #background{
        position:absolute;
        z-index:1;
        
        display:block;
        opacity: 0.5;
    }

    #bg-text
    {
        color:lightgrey;
        font-size: 10em;
        margin-top: 50%;
        transform:rotate(300deg);
        -webkit-transform:rotate(330deg);
    }

}
</style>